import React from 'react';

const LoadingSpinner = () => (
  <div>
    <i className="fa fa-spinner fa-spin text-primary" /> Cargando ...
  </div>
);

export default LoadingSpinner;